import React from 'react';
import { Card, Table, Tag, Button } from 'antd';
import { useNavigate } from 'react-router-dom';
import type { ControlTowerQueryParams } from '@/services/manufacturingControlTower.service';
import { useControlTowerTraceability } from '@/hooks/useManufacturingControlTower';

const TraceabilityCenter: React.FC<{ filters?: ControlTowerQueryParams }> = ({ filters }) => {
  const navigate = useNavigate();
  const { data, isLoading } = useControlTowerTraceability({ page_size: 100, ...filters });
  const rows = (data as { rows?: Record<string, unknown>[] })?.rows ?? [];

  return (
    <Card
      id="traceability"
      title="Heat number & traceability"
      extra={
        <Button size="small" onClick={() => navigate('/mfg/traceability-matrix')}>
          Open matrix
        </Button>
      }
      style={{ marginTop: 16 }}
    >
      <Table
        size="small"
        loading={isLoading}
        rowKey="id"
        dataSource={rows}
        onRow={(r) => ({
          onClick: () => r.deepLink && navigate(String(r.deepLink)),
          style: { cursor: 'pointer' },
        })}
        columns={[
          { title: 'Heat', dataIndex: 'heat_number' },
          { title: 'WO', dataIndex: 'work_order_number' },
          { title: 'Material', dataIndex: 'raw_item_code' },
          {
            title: 'MTC',
            dataIndex: 'mtc_missing',
            render: (m: boolean) => (m ? <Tag color="red">Missing</Tag> : <Tag color="green">OK</Tag>),
          },
          { title: 'Qty', dataIndex: 'quantity', width: 70 },
        ]}
        pagination={{ pageSize: 15 }}
      />
    </Card>
  );
};

export default TraceabilityCenter;
